import { PaletteColorOptions, createTheme } from "@mui/material/styles";
//import Button, { ButtonPropsColorOverrides } from '@mui/material/Button';

declare module '@mui/material/styles' {
  interface CustomPalette {
    cocoa?: PaletteColorOptions;
    goldy?: PaletteColorOptions;
    lemon?: PaletteColorOptions;
    oldie?: PaletteColorOptions;
    pinky?: PaletteColorOptions;
    tealy?: PaletteColorOptions;
  }
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    cocoa: true;
    goldy: true;
    lemon: true;
    oldie: true;
    pinky: true;
    tealy: true;
  }
}

const { palette } = createTheme();
const { augmentColor } = palette;
export const createColor = (mainColor:any) => augmentColor({ color: { main: mainColor } });
// const theme = createTheme({
//   palette: {
//     anger: createColor('#F40B27'),
//     apple: createColor('#5DBA40'),
//     steelBlue: createColor('#5C76B7'),
//     violet: createColor('#BC00A3'),
//   },
// });